import type { ReleaseGroupRouteParams } from '../projects/project_grouping/types';
import type { RevisionRouteParams } from '../projects/projectDashboardTypes';

export type ReportType = 'licensing' | 'sbom' | 'vulnerability' | 'remediationGuidance';

// This is the user-facing name of the report, which is displayed in the heading and sidebar.
export type ReportHeading = 'Licensing' | 'SBOM' | 'Vulnerabilities' | 'Remediation Guidance';

export type ReportsRouteParams = {
  reportType: ReportType;
};

//  If we are on the project page, then we will have the project revision params.
//  We include them in this type, as we use it to check if we are on
type ProjectReportParams = ReportsRouteParams & RevisionRouteParams;
type ReleaseGroupReportParams = ReportsRouteParams & ReleaseGroupRouteParams;

export type ReportsV3Params =
  | ProjectReportParams
  | ReleaseGroupReportParams;

/**
 * Type guard for checking if the params are for a release group scope.
 */
export const isReleaseGroupScope = (params: ReportsV3Params): params is ReleaseGroupReportParams => {
  //  Despite being typed as a number, the projectGroupId is really a string which needs to be cast to a number.
  return 'projectGroupId' in params && Number.isFinite(Number(params.projectGroupId));
};

/**
 * The two types of report flows.
 */
export type ReportFlow = 'standard' | 'custom';

/**
 * These represent the possible query params for the reports v3 page.
 * TODO: this will eventually hold all the possible report options, so that sets of options
 * can be shared (even if they are not "saved").
 */
export type ReportsV3QueryParams = Readonly<Partial<{
  flow: ReportFlow;
}>>;
